import { AdBlockerType } from "../types";
import { LocalSettings } from "../../settings";
import { sendEvent, topmostAccessibleWindow } from "../utils";
import { hasBounceData, saveBounceData } from "../data";

export const onBounce = (
  detectedExtension: AdBlockerType,
  settings: LocalSettings,
) => {
  const [navigationEntry] =
    topmostAccessibleWindow.performance.getEntriesByType("navigation") as
      | PerformanceNavigationTiming[]
      | [];
  const isReload = navigationEntry?.type === "reload";
  if (!hasBounceData() && !isReload) {
    saveBounceData();
    sendEvent({
      event: "navigate-away",
      detectedExtension: detectedExtension,
      renderMode: settings.render_mode,
    }).catch(() => null);
  }
};
